/**
 * Component to filter user lists
 */
import * as React from 'react';
import { Card, Row, Col, Input, Checkbox } from 'antd';
import '../../css/UserFilter.scss';
import auth from '../common/auth';
import Utils from '../common/utils';
import strings from '../../eyeguide-localization/employee/strings.employee.filter';
import Token from '../common/token';

const CheckboxGroup = Checkbox.Group;

interface IFilterProps {
    notifyChangeFilter: any; 
    filterObj: any;
    orgs: any;
}
    
interface IFilterState {
    sportsArr: any;
    isOpen: boolean;
    filterObj: any;
    roles: any;
    orgs: any;
}

export default class EmployeeFilter extends React.Component<IFilterProps, IFilterState> {
    username: any;
    constructor(props: IFilterProps) {
        super(props); 
        this.username = '';
        this.state = {
            sportsArr: [],
            isOpen: false,
            roles: [],
            orgs: [],
            filterObj: {
                'username' : '',
                'firstname' : '',
                'lastname' : '',
                'email' : '',
                'role': [],
                'organizations' : []
            }
        };
    }

    componentDidMount() {
        let roles: any = []; 
        let roleid: number = parseInt(Token.decodeToken().roleid, 10);
        let allRoles: any = auth.getRolesByRole(roleid);
        allRoles.forEach((value: any) => {
            roles.push({name: Utils.cascadeStringCase(auth.getRoleName(value).replace(new RegExp('_', 'g'), ' ')), 
                            id: value});
        });
        // let orgs : 
        this.setState({
             filterObj: this.props.filterObj,
             roles: roles,
             orgs: this.props.orgs
        });
        setTimeout(() => {this.username.focus() ; }, 1);
    }
    
    componentWillReceiveProps(nextProps: any) {
        console.log('next props',  nextProps.filterObj);
        this.setState({
            isOpen: nextProps.isOpen,
            filterObj: nextProps.filterObj,
            orgs: nextProps.orgs
        });
    }

    render() {
        return(
            <div className="UserFilter">
                <Card className="filterCard" bordered={false} style={{ margin: '24px 16px' }} >
                    <Row className="row">
                        <Col xs={1} sm={1} md={2} lg={5} xl={5} />
                        <Col xs={8} sm={8} md={5} lg={3} xl={3} className="labelFrame">
                            <div className="label">
                                <span> {strings.lsUsrNameTxt}
                                :</span>
                            </div>
                        </Col>
                        <Col xs={14} sm={14} md={16} lg={10} xl={11}>
                            <Input 
                                ref={val => this.username = val}
                                defaultValue=""
                                placeholder={strings.lsUsrNamePlaceholderTxt} 
                                onChange={(val) => this.handleChange(val.target.value, 'username')}
                                value={this.state.filterObj.username}
                            />
                        </Col>
                        <Col xs={1} sm={1} md={2} lg={6} xl={4}/>                   
                    </Row>
                    <Row className="row">
                        <Col xs={1} sm={1} md={2} lg={5} xl={5} />
                        <Col xs={8} sm={8} md={5} lg={3} xl={3} className="labelFrame">
                            <div className="label">
                                <span>   {strings.lsFNameTxt} 
                                :</span>
                            </div>
                        </Col>
                        <Col xs={14} sm={14} md={16} lg={10} xl={11}>
                            <Input 
                                placeholder={strings.lsFNamePlaceholderTxt}
                                onChange={(val) => this.handleChange(val.target.value, 'firstname')}
                                value={this.state.filterObj.firstname}
                            />
                        </Col>
                        <Col xs={1} sm={1} md={2} lg={6} xl={4}/>
                    </Row>
                    <Row className="row">
                        <Col xs={1} sm={1} md={2} lg={5} xl={5} />
                        <Col xs={8} sm={8} md={5} lg={3} xl={3} className="labelFrame">
                        <div className="label">{strings.lsLNameTxt} :</div></Col>
                        <Col xs={14} sm={14} md={16} lg={10} xl={11}>
                        <Input 
                            placeholder={strings.lsLNamePlaceholderTxt} 
                            onChange={(val) => {console.log('inputchanged', val.target.value);
                                                this.handleChange(val.target.value, 'lastname'); }}
                            value={this.state.filterObj.lastname}
                        />
                        </Col>
                        <Col xs={1} sm={1} md={2} lg={6} xl={4}/>
                    </Row>
                    <Row className="row">
                        <Col xs={1} sm={1} md={2} lg={5} xl={5} />
                        <Col xs={8} sm={8} md={5} lg={3} xl={3} className="labelFrame">
                        <div className="label">{strings.lsEmailTxt} :</div></Col>
                        <Col xs={14} sm={14} md={16} lg={10} xl={11}>
                        <Input 
                            placeholder={strings.lsEmailPlaceholderTxt} 
                            onChange={(val) => {console.log('inputchanged', val.target.value);
                                                this.handleChange(val.target.value, 'email'); }}
                            value={this.state.filterObj.email}
                        />
                        </Col>
                        <Col xs={1} sm={1} md={2} lg={6} xl={4}/>
                    </Row>
                    <Row className="row" >
                        <Col xs={1} sm={1} md={2} lg={5} xl={5} />
                        <Col xs={8} sm={8} md={5} lg={3} xl={3} className="labelFrame">
                        <div className="label">{strings.lsRoleTxt} :</div></Col>
                        <Col xs={14} sm={14} md={16} lg={10} xl={11}>
                        <CheckboxGroup 
                            className="labelFrame"
                            style={{ width: '100%' }} 
                            onChange={(val) => {console.log('val of sports', val);
                                                this.handleChange(val, 'role');
                                                }}
                            value={this.state.filterObj.role} 
                        >
                            <Row>
                                {this.state.roles.map(x => <Col key={x.id} span={15}>
                                <Checkbox 
                                    value={x.id} 
                                    key={x.id}
                                >
                                {x.name}                  
                                </Checkbox></Col>)}
                            </Row>
                        </CheckboxGroup>
                        </Col>
                        <Col xs={1} sm={1} md={2} lg={6} xl={4}/>
                    </Row>
                    {this.state.orgs.length > 0 ?
                    <Row className="row" >
                        <Col xs={1} sm={1} md={2} lg={5} xl={5} />
                        <Col xs={8} sm={8} md={5} lg={3} xl={3} className="labelFrame">
                        <div className="label">{strings.lsOrgTxt} :</div></Col>
                        <Col xs={14} sm={14} md={16} lg={10} xl={11}>
                        <CheckboxGroup 
                            className="labelFrame"
                            style={{ width: '100%' }} 
                            onChange={(val) => {console.log('val of sports', val);
                                                this.handleChange(val, 'organizations');
                                                }}
                            value={this.state.filterObj.organizations} 
                        >
                            <Row>
                                {this.state.orgs.map(x => <Col key={x.organizationid} span={15}>
                                <Checkbox 
                                    value={x.organizationid} 
                                    key={x.organizationid}
                                >
                                {x.name}                  
                                </Checkbox></Col>)}
                            </Row>
                        </CheckboxGroup>
                        </Col>
                        <Col xs={1} sm={1} md={2} lg={6} xl={4}/>
                    </Row>
                    : '' }
                </Card>
            </div>
        );
    }

    private handleChange(e: any, prop: string) {
        console.log('handleChange', e);
        if (!(e instanceof Array) && e.toString().trim().length === 0) {
            e = '';
        }
        let filterObj = this.state.filterObj;
        filterObj[prop] = e;
        this.setState({
            filterObj: filterObj
        });
        console.log('this.state.filterObj', this.state.filterObj);
        this.props.notifyChangeFilter(this.state.filterObj);
    }

}


// WEBPACK FOOTER //
// ./src/components/employee/EmployeeFilter.tsx